import YourOrder from "components/ui/YourOrder/YourOrder";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CircleCheckmarkIcon from "../../../../assets/icons/CircleCheckmarkIcon";
import CircleErrormarkIcon from "../../../../assets/icons/CircleErrormarkIcon";
import styles from "./styles.module.scss";
import useGetQuote from "hooks/api/useGetQuote";
import useGetStatus from "hooks/api/useGetStatus";
import { useMutatePay } from "api/mutations";
import useGetData from "hooks/api/useGetData";
import { EnumPaymentStatus } from "types/api/api";
import { useAppContext } from "context/AppContext";

const ResultScreen = () => {
  const { id = "123" } = useParams();
  const { t, i18n } = useTranslation();
  const appContext = useAppContext();

  const { isLoading } = useGetData();
  const { isError: isErrorQuote, error: errorQuote } = useGetQuote();
  const {
    data: dataStatus,
    isError: isErrorStatus,
    isLoading: isLoadingStatus,
    error: errorStatus
  } = useGetStatus({});
  // eslint-disable-next-line
  const { isError: isErrorPay, error: errorPay }: { isError: boolean; error: any } = useMutatePay(id);

  const renderStatusMessage = () => {
    if (isErrorQuote && errorQuote?.data?.errorMsg) {
      return errorQuote?.data?.errorMsg;
    }

    if (isErrorStatus && errorStatus?.data?.errorMsg) {
      return errorStatus?.data?.errorMsg;
    }

    if (isErrorPay && errorPay?.data?.errorMsg) {
      return errorPay?.data?.errorMsg;
    }

    return "";
  };

  const renderPaymentErrorMessage = () =>
    dataStatus?.error?.description?.find((l) => l.lang === i18n.language)?.text;

  const SuccessScreen = () => {
    return (
      <div>
        <CircleCheckmarkIcon className={styles.checkmarkIcon} />
        <div className="m-h2" data-testid="heading-first">
          {t("successScreen.orderProceeded")}
        </div>
      </div>
    );
  };
  const ErrorScreen = () => {
    return (
      <div>
        <CircleErrormarkIcon />
        <div className="m-h2-error" data-testid="heading-first-error">
          {t("errorScreen.heading1")}
        </div>
        <div className={styles.errorMessage} data-testid="error-message">
          {dataStatus?.status === EnumPaymentStatus.ERRORED
            ? renderPaymentErrorMessage()
            : renderStatusMessage()}
        </div>
        {/* TODO: Make usage for try-again button */}
        {/*{dataStatus?.status !== ORDER_STATUS_SUCCESS && (*/}
        {/*  <div className={styles.buttonWrapper2}>*/}
        {/*    <Button*/}
        {/*      dataTestId="try-button"*/}
        {/*      onClick={handleTryAgainClick}*/}
        {/*      variant="primary"*/}
        {/*      title={t("errorScreen.buttonTitle1")}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*)}*/}
        <div className="m-divider-dashed-error"></div>
        <div className="m-h2">{t("errorScreen.heading2")}</div>
        <div className={styles.info}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>{t("errorScreen.accountNumber")}</span>
            <span className={styles.infoValue}>{appContext?.paymentInput}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>{t("errorScreen.paymentMethode")}</span>
            <span className={styles.infoValue}>{appContext?.paymentMethod}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {dataStatus?.status === EnumPaymentStatus.SUCCESS ? <SuccessScreen /> : <ErrorScreen />}

      <div className={styles.oderWithFees}>
        {/* Here, your order is taking a quote information from statusQuery as user already started a payment process */}
        {!isLoading && <YourOrder isLoading={isLoadingStatus} />}
      </div>

      {/* {dataStatus?.status !== ORDER_STATUS_SUCCESS && (
        <div className={styles.buttonWrapper}>
          <Button
            to={`/${id}`}
            testId="back-button"
            variant="primary"
            title={t("successScreen.buttonTitle1")}
          />
        </div>
      )} */}
    </div>
  );
};

export default ResultScreen;
